/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { checkToken } from '@builddocs/data-management'
import axios from 'axios'

export const InformationAPI = axios.create({
  baseURL: '/information-service/api/v1',
})

InformationAPI.interceptors.request.use(function (config) {
  return checkToken(config)
})
